export default __webpack_public_path__ + "static/media/ENGLISH_GRAMMAR.0caf2074.svg";